import http from '@/api/http';

export default {
  //获取机构信息
  getUserMsg: () => {
    return http.post('/host/manage/v1/operator/info');
  },
  //修改密码
  changePassword: (opts = {}) => {
    return http.post('/host/manage/v1/auth/update', {
      body: {
        oid: opts.oid,
        password: opts.password,
        newpassword: opts.newpassword,
      },
    });
  },
};
